import { render } from "./LikeFiles.vue?vue&type=template&id=9110aa22&scoped=true"
import script from "./LikeFiles.vue?vue&type=script&lang=js"
export * from "./LikeFiles.vue?vue&type=script&lang=js"

import "./LikeFiles.vue?vue&type=style&index=0&id=9110aa22&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9110aa22"

export default script